export default __webpack_public_path__ + "media/zurb/img/home/home-work-paysa-5887cc733fef2da760b9dbfcf3a5ed46.png";